import * as api from '../../services/experience'

export const FETCH_EXPERIENCES= 'FETCH_EXPERIENCES';




export const fetchExperiences = (params, pagination, sort, extra) => {

    return {
        type: FETCH_EXPERIENCES,
        payload: {
            promise: api.findExperiences(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/experience.js